import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { FormHelperService } from 'src/app/core/helpers/form-helper/form-helper.service';
import { AppointmentInventory } from 'src/app/core/models/appointment-inventory.model';
import { Appointment } from 'src/app/core/models/appointment.model';
import { CustomerService } from 'src/app/core/models/customer-service.model';
import { EquipmentAttribute } from 'src/app/core/models/equipment-attribute.model';
import { InventoryAttribute } from 'src/app/core/models/inventory.model';
import { EquipmentService } from 'src/app/core/services/equipment/equipment.service';
import { InventoryFormHelperService } from 'src/app/core/services/inventory/inventory-form-helper.service';
import { InventoryService } from 'src/app/core/services/inventory/inventory.service';
import { TicketProvisioningService } from 'src/app/core/services/ticket-provisioning/ticket-provisioning.service';

@Component({
	selector: 'app-edit-inventory',
	templateUrl: './edit-inventory.component.html',
	styleUrls: ['./edit-inventory.component.scss'],
})
export class EditInventoryComponent implements OnInit {

	pageTitle = 'Edit Inventory';

	@Input()
	inventoryItem: AppointmentInventory;

	@Input()
	appointment: Appointment;

	dynamicAttributes = [] as EquipmentAttribute[];
	form: FormGroup;
	serviceOptions: CustomerService[];

	constructor(
		public formHelper: FormHelperService,
		public inventoryFormHelper: InventoryFormHelperService,
		private modalController: ModalController,
		private equipmentService: EquipmentService,
		private formBuilder: FormBuilder,
		private inventoryService: InventoryService,
		private toastController: ToastController,
		private ticketProvisioningService: TicketProvisioningService
	) { }

	async ngOnInit() {
		if (this.inventoryItem.attributes.length > 1) {
			const equipmentAttributes = await this.equipmentService.getAttributes();
			this.dynamicAttributes = this.inventoryFormHelper
				.getDynamicAttributes(equipmentAttributes, this.inventoryItem.attributes);
			const { formFields, serviceOptions } = await this.inventoryFormHelper
				.buildDynamicForm(this.dynamicAttributes, this.appointment, this.serviceOptions);

			this.serviceOptions = serviceOptions;
			this.form = this.formBuilder.group(formFields);
		}
	}

	async onSaveInventory() {
		this.form = this.formHelper.markAsTouched(this.form);
		if (this.form.invalid) {
			await this.formHelper.alertUser();
			return;
		}

		const form = this.form.value;
		const inventoryUpdates = [] as InventoryAttribute[];
		for (let index = 0; index < this.dynamicAttributes.length; index++) {
			const attribute = this.dynamicAttributes[index];
			if (attribute.originalValue !== form[index]) {
				inventoryUpdates.push({
					id: attribute.id,
					value: form[index]?.toString()
				});
			}
		}

		if (inventoryUpdates.length > 0) {
			await this.inventoryService.updateInventoryAttributes(this.appointment.id, this.inventoryItem.id, inventoryUpdates);
		}
		await this.ticketProvisioningService.addProvision(this.appointment.id, this.inventoryItem);

		await this.toastSaveSuccess();
		await this.dismiss(inventoryUpdates);
	}

	async dismiss(inventoryUpdates?: InventoryAttribute[]): Promise<void> {
		await this.modalController.dismiss({
			dismissed: true,
			inventoryUpdates,
		});
	}

	private async toastSaveSuccess(): Promise<void> {
		const toast = await this.toastController.create({
			message: 'Successfully saved edits.',
			duration: 3000,
			position: 'top',
			color: 'success',
			buttons: ['Dismiss'],
		});

		await toast.present();
	}
}
